import { ISelectLanguagesProps } from "./Interfaces";
import { Row, Col, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./css/SelectLanguages.css";
import { ComponentStruct } from "../../common/Interfaces";
import { languages } from "../../common/Contants";

export default function SelectLanguages({
  onChange,
  defaultLanguages,
  clear,
  allLanguages,
}: ISelectLanguagesProps) {
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>(
    defaultLanguages || (allLanguages ? languages.map((lang) => lang.key) : [])
  );
  const [allSelected, setAllSelected] = useState<boolean>(
    defaultLanguages?.length === languages.length ||
      defaultLanguages?.includes("all") ||
      allLanguages
  );

  const handleSelectAllChange = (checked: boolean) => {
    setAllSelected(checked);
    let updatedLanguages = checked ? languages.map((lang) => lang.key) : [];
    setSelectedLanguages(updatedLanguages);
    onChange(updatedLanguages);
  };

  const handleLanguageChange = (language: string, checked: boolean) => {
    let updatedLanguages = [...selectedLanguages];
    if (checked) {
      updatedLanguages.push(language);
    } else {
      updatedLanguages = updatedLanguages.filter((lang) => lang !== language);
    }
    setSelectedLanguages(updatedLanguages);
    setAllSelected(updatedLanguages.length === languages.length);
    onChange(updatedLanguages);
  };

  useEffect(() => {
    const allSelected =
      defaultLanguages?.length === languages.length ||
      defaultLanguages?.includes("all") ||
      allLanguages;
    setAllSelected(allSelected);
    setSelectedLanguages(
      defaultLanguages || (allSelected ? languages.map((lang) => lang.key) : [])
    );
    onChange(
      defaultLanguages || (allSelected ? languages.map((lang) => lang.key) : [])
    );
  }, [clear]);

  useEffect(() => {
    if (defaultLanguages && defaultLanguages[0] == "all") {
      setSelectedLanguages(languages.map((lang) => lang.key));
      setAllSelected(true);
    }
  }, [defaultLanguages]);
  return (
    <Row className="padding-top">
      <Col xs={2}>
        <label>Language</label>
      </Col>
      <Col xs={1}>
        <Form className={"custom-checkbox"}>
          <Form.Check
            id={"all"}
            type="checkbox"
            label={"ALL"}
            checked={allSelected}
            className={"small-label"}
            onChange={(e) => handleSelectAllChange(e.target.checked)}
          />
        </Form>
      </Col>
      <Col xs={9}>
        <div className={"language-grid"}>
          {languages.map((lan: ComponentStruct) => (
            <Form key={lan.key} className={"custom-checkbox"}>
              <Form.Check
                id={lan.key}
                type="checkbox"
                label={lan.label}
                className={"small-label"}
                checked={allSelected || selectedLanguages.includes(lan.key)}
                onChange={(e) =>
                  handleLanguageChange(lan.key, e.target.checked)
                }
              />
            </Form>
          ))}
        </div>
      </Col>
    </Row>
  );
}
